<template lang="pug">
  .app-toolbar.d-flex.align-center
    v-btn.mr-5(icon @click.stop="setSidebarVisible(!sidebarVisible)")
      v-icon(color="primary") menu

    h2.primary--text Risiko Management Service
    // account_balance apartment
    v-spacer

    template(v-if="selectedCompany")
      v-icon.mr-1(color="primary") account_balance
      span.grey--text.text--darken-3.mr-6 {{ selectedCompany.name }}

    template(v-if="selectedAgency")
      v-icon.mr-1(color="primary") group_work
      span.grey--text.text--darken-3.mr-6 {{ selectedAgency.name }}

    v-icon.mr-1(color="primary") person
    span.grey--text.text--darken-3 {{ userName }}

    v-btn.ml-5(text icon @click.stop="onLogout")
      v-icon(color="primary") exit_to_app

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'

@Component({
  computed: mapGetters([
    'selectedAgency',
    'selectedCompany',
    'sidebarVisible',
    'userName'
  ]),

  methods: mapActions([
    'logout',
    'setSidebarVisible'
  ])
})
export default class ToolBar extends Vue {
  clipped = true

  onLogout () {
    this.$confirmDialog.show({
      text: 'Wirklich abmelden?',
      handleOk: () => {
        this.logout()
        this.$confirmDialog.close()
      }
    })
  }
}
</script>
